











































// @ is an alias to /src
import { Component, Vue, Watch } from "vue-property-decorator";
import PreviewComponent from "@/components/Preview.vue";
import ControlComponent from "@/components/Control.vue";
import DownloadComponent from "@/components/Download.vue";
import { RadialStripe, ScreenIndicator } from "@/lib";

@Component({
  components: {
    PreviewComponent,
    ControlComponent,
    DownloadComponent
  }
})
export default class HelloWorld extends Vue {
  radialStripe: RadialStripe = new RadialStripe();
  indicator: ScreenIndicator = new ScreenIndicator();

  @Watch("radialStripe", { deep: true })
  onChanged() {
    window.localStorage.setItem(
      "radialStripe",
      JSON.stringify(this.radialStripe)
    );
  }

  created() {
    const json = window.localStorage.getItem("radialStripe");
    if (json) {
      try {
        const values = JSON.parse(json);
        this.radialStripe = new RadialStripe(values);
      } catch (ex) {
        console.error(ex);
      }
    }
  }
}
